import styled from 'styled-components'

const MyDiv = styled.div`
// margin-top:100px;
margin-bottom: 100px;
position: relative;
.page_heading{
    background: #f6f6f6;
    border-bottom: 1px solid #ddd;
    box-shadow: 0px 2px 2px 0px rgb(50 50 50 / 10%);
    top: 0px;
    position: fixed;
    left: 0;
    z-index: 111;
    width: 100%;
}
.ka-paging-sizes-active{
  background: #f6f6f6;
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0px;
  z-index: 111;
}
.page_heading p{
    margin: 0;
    text-align: left;
    padding: 10px 30px;
    font-size: 20px;
    color: #555;
    font-weight: 600;
    text-transform: uppercase;
    font-family: "Arial";
}
.column_setting{
    color: #000;
    position: absolute;
    right: 10px;
    z-index: 1111;
}
.ka-cell{
    padding: 5px 10px!important;
}
.button_group{
    display: flex;
    align-items:center;
    column-gap: 20px;
    margin-bottom: 20px;
}

.buttons_flex{
    display: flex;
    align-items:center;
    justify-content: space-between;
}
.total_assets{
    font-size: 14px;
    color: #333;
    font-weight: 600;
    font-family: "Arial";
}
.align_switch{
    display: flex;
    align-items: center;
    justify-content: center;
  }
`
export default MyDiv
